import { render, staticRenderFns } from "./TreatmentProductList.vue?vue&type=template&id=163d6b14&scoped=true&"
import script from "./TreatmentProductList.vue?vue&type=script&lang=js&"
export * from "./TreatmentProductList.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentProductList.vue?vue&type=style&index=0&id=163d6b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163d6b14",
  null
  
)

export default component.exports